
import { ALL_DOCTORS_USERS, ALL_ROOMS, CLANIC_DOCTOR_SERVICES, USER_FAQ, ALL_CONTACT_FORMS } from '../types'



const addUserFaq = (userFaq) => {
    return {
        type: USER_FAQ,
        userFaq
    }
}

const addClanicServices = (clanicServices) => {
    return {
        type: CLANIC_DOCTOR_SERVICES,
        clanicServices
    }
}

const addAllDoctorsUser = (allDoctorsUser) => {
    return {
        type: ALL_DOCTORS_USERS,
        allDoctorsUser
    }
}

const addAllRooms = (allRooms) => {
    return {
        type: ALL_ROOMS,
        allRooms
    }
}

const addAllContactForms = (allContactforms) => {
    return {
        type: ALL_CONTACT_FORMS,
        allContactforms
    }
}

export {
    addUserFaq,
    addClanicServices,
    addAllDoctorsUser,
    addAllRooms,
    addAllContactForms
}
